import * as React from 'react';

function SvgIconEye(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.722 6.597c-1.482-3.12-3.72-4.69-6.722-4.69-3.004 0-5.241 1.57-6.722 4.691a.942.942 0 000 .805c1.481 3.12 3.72 4.69 6.722 4.69 3.003 0 5.24-1.57 6.722-4.691a.942.942 0 000-.805zM7 10.969C4.48 10.969 2.634 9.69 1.332 7 2.634 4.31 4.48 3.031 7 3.031c2.52 0 4.365 1.278 5.667 3.969-1.3 2.69-3.146 3.969-5.667 3.969zM6.937 4.25a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zm0 4.5a1.75 1.75 0 110-3.5 1.75 1.75 0 110 3.5z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgIconEye;
